(function () {
	'use strict';

	a3_cabin_reports.controller('GroomimgCategoriesModalCtrl', GroomimgCategoriesModalCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name GroomimgCategoriesModalCtrl
    * @description 
    * Grooming Categories Form Modal
    * @ngInject
    */
	function GroomimgCategoriesModalCtrl($scope, $uibModalInstance, crewData, groomingCategories) {
		$scope.crewData = crewData;

        const originalCategories = angular.copy(groomingCategories); // Deep copy for preservation
        $scope.groomingCategories = angular.copy(groomingCategories); // Working copy for the modal
		$scope.close = close;
        $scope.save = save;

        $scope.isSaveEnabled = function() {
            return $scope.groomingCategories.every(category => {
                if (category.isSelected) {
                    return category.UserInput && category.UserInput.trim() !== '';
                }
                return true;
            });
        };
        

        $scope.toggleCategorySelection = function(category) {
            category.isSelected = !category.isSelected;
        
            // Clear remarks if the category is unchecked
            if (!category.isSelected) {
                category.UserInput = ""; // Reset the input field
            }
        };
        
        // Function to clear specific input
        $scope.clearInput = function (category) {
            category.UserInput = ''; 
        };

        // Close the modal
		function close() {
            $scope.groomingCategories = angular.copy(originalCategories);
            $uibModalInstance.dismiss('cancel');
		}

        function save () {
            angular.copy($scope.groomingCategories, groomingCategories);
            // Close the modal and return the updated grooming categories
            $uibModalInstance.close($scope.groomingCategories);
        };
	}
})();